import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useParams, useSelector } from 'umi';
import Permission from '@/pages/dashboard/components/NoPermission';
import Loading from '@/pages/dashboard/components/Loadings';
import {
  getDashboardType,
  getDashAppReportId,
  getPathFromDashboard, checkReportIdWithName,
} from '@/pages/dashboard/utils/utils';
import {
  LOG_SYSTEM_TYPE,
  PAGE_TYPE_DASHAPP,
  PAGE_TYPE_PRESET,
  PAGE_TYPE_TABLEAU,
} from '@/pages/dashboard/_config/constant';
import { buriedPoint } from '@/pages/home/utils/buriedPoint';


interface ReportInfoType {
  loading: boolean;
  noReport: boolean;
}

const INIT_REPORT_INFO: ReportInfoType = {
  noReport: false,
  loading: false,
};

// todo 正式上线，token需要从后端获取
const TOKEN = 'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MDQwMzgzOTksInVzZXJuYW1lIjoiamFzb256eHlpbiIsIm5hbWUiOiJqYXNvbnp4eWluIiwiY29tcGFueSI6IlRlbmNlbnRJRUdHIiwiaXNzIjoiREFTSCBFTUJFRERFRCIsImF1ZCI6Imphc29uenh5aW4tZGVtbyJ9.xLKgRpvYcvemh1N1VDtLcJxlbfa-Pi1SyGVL1pCDnAPA3xfLDmvTgZpoUdquvH8P38U1iIrMM92WwQpsvLbovA'

export default (props: any) => {
  const [reportInfo, setReportInfo] = useState<ReportInfoType>(INIT_REPORT_INFO);
  const { reportId } = useParams() as any;
  const { currentMenu, currentGame } = useSelector(state => {
    const { currentMenu, currentGame } = state.dashboard;
    return {
      currentMenu,
      currentGame
    }
  });

  const setState = (params = {}) => {
    setReportInfo({
      ...INIT_REPORT_INFO,
      ...params
    });
  }

  const init = async () => {
    if (!reportId || !currentGame ) {
      return;
    }
    if (!currentMenu || getDashboardType(currentMenu) !== PAGE_TYPE_DASHAPP || !checkReportIdWithName(reportId, currentMenu?.name_en)) {
      return;
    }
    const { url } = currentMenu;
    if (!url) {
      setState({noReport: true});
      return;
    }
    setState({noReport: false});

    // @ts-ignore
    const dashEmbeddedComponent = await import('./dash-embedded-component-2.6.0.min.js');
    dashEmbeddedComponent.renderDash(
      {
        url_base_pathname: url,
        auth_token: TOKEN, // Replace with your actual auth token
      },
      'report-iframe-wrap'
    );
    const { game_code: gameCode } = currentGame;
    // 打点
    const { id = '', name_en: nameEn } = currentMenu || {};
    const logObj = {
      pageId: id,
      menuId: id,
      pageName: nameEn,
      extInfo: nameEn,
      pagePath: getPathFromDashboard(currentMenu),
      uid: gameCode,
      typeId: LOG_SYSTEM_TYPE,
    };
    buriedPoint(logObj);
  }

  const errorInfo = useMemo(() => {
    // 路径中无reportid
    if (!reportId) {
      return <Permission type="error" textCN="未获取到报表信息" />
    }
    // 无currentMenu，或者currentMenu不是tableau，或者currentMenu跟路径中的reportId不匹配，说明currentMenu 未更新，等待currentMenu更新，此时执行loading等待
    if (!currentMenu || getDashboardType(currentMenu) !== PAGE_TYPE_DASHAPP || reportInfo.loading || !checkReportIdWithName(reportId, currentMenu?.name_en)) {
      return <Loading />;
    }
    // 路径中无reportid
    if (reportInfo.noReport) {
      return <Permission type="error" textCN="未获取到报表信息" />
    }
    return null;
  }, [currentMenu, reportId, reportInfo]);

  useEffect(() => {
    init();
  }, [reportId, currentMenu]);

  return (
    <div key={currentMenu?.url} className='dtb-db-iframe-wrap' id="report-iframe-wrap">{errorInfo}</div>
  );

};
